import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

export const root = css`
  display: block;
  margin: var(${spacing.xxs}) 0 var(${spacing.sm});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});

  em {
    font-style: normal;
    color: var(${colors.content.positive});
  }
`;
